import React, {useEffect} from 'react';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import {connect} from 'react-redux';
import {isMobileOnly} from 'react-device-detect';
import images from '../images/images';
import './CancelPackagePopUp.scss';
import {gaEvent} from '../../../../../utilities/analytics/tracking';
import gaParams from '../../../../../utilities/analytics/constants';
import Lottie from 'react-lottie';
import PaperPlane from '../../../../../animations/paperPlane.json';
import ThemedLottie from '../../../../Shared/ThemedLottie/ThemedLottie';
import { ThemeColorEnum } from '../../../../../utilities/theme/ThemeColorEnum';
const CancelPackagePopUp = ({cancelPackage, onClose}) => {
  useEffect(() => {
    gaEvent(
      gaParams.ABROAD_MY_ABROAD_SHOW_CANCEL_PACKAGE_POP_UP.category,
      gaParams.ABROAD_MY_ABROAD_SHOW_CANCEL_PACKAGE_POP_UP.eventType,
      gaParams.ABROAD_MY_ABROAD_SHOW_CANCEL_PACKAGE_POP_UP.category
    );
    // TBD : on destroy consider adding reset to socPackageRemoveStatus back to null
  }, []);

  function goBack() {
    gaEvent(
      gaParams.ABROAD_MY_ABROAD_CLICK_DO_NOT_CANCEL_PACKAGE_POP_UP.category,
      gaParams.ABROAD_MY_ABROAD_CLICK_DO_NOT_CANCEL_PACKAGE_POP_UP.eventType,
      gaParams.ABROAD_MY_ABROAD_CLICK_DO_NOT_CANCEL_PACKAGE_POP_UP.eventParams
    );
    onClose();
  }

  async function cancelAndClose() {
    await cancelPackage();
  }

  return (
    <div className='cancel-package-pop-up-container'>
      <div className='header'>ביטול חבילה</div>
      {/* <Lottie options={{animationData: PaperPlane, loop: false}} width={isMobileOnly ? 200 : 250} /> */}
      <ThemedLottie animationData={PaperPlane} color={ThemeColorEnum.PRIMARY} width={isMobileOnly ? 200 : 250} />
      <div className='top-paragraph'>בטוח שאתם רוצים לטוס בלי חבילה?</div>
      <div className='bottom-paragraph'>
        שימוש בנייד בחו"ל ללא חבילת חו"ל,
        <br /> יתכן ויגרור חיובים גבוהים
      </div>
      <BtnSubmit onclick={() => goBack()} text={`אני רוצה להשאיר את החבילה`} />
      <div className='cancel-package-line' onClick={() => cancelAndClose()}>
        בטלו את החבילה
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CancelPackagePopUp);
